import { ca } from '@cian/analytics';

export const trackGetTicketClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'DemandCpd',
    action: 'click',
    label: 'form',
  });
};

export const trackGetConsultationClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'DemandCpd',
    action: 'click',
    label: 'consultation',
  });
};
